import React from "react";

import { RemoveActionProvider } from "@beeldit/ecommerce/products/actions/remove/RemoveActionContext";
import { CreateActionProvider } from "@beeldit/ecommerce/products/actions/create/CreateActionContext";
import { ListActionProvider } from "@beeldit/ecommerce/products/actions/list/ListActionContext";
import ProductsPage from "@beeldit/ecommerce/products/pages/ProductsPage";


export default function ProductsRouterWrapper(props: { filters?: any, formDefaultValues?: any, formFilterValues?: any }) {
    const { filters, formDefaultValues, formFilterValues } = props;
    return (
      <ListActionProvider>
          <RemoveActionProvider>
              <CreateActionProvider>
                  <ProductsPage filters={filters} formDefaultValues={formDefaultValues} formFilterValues={formFilterValues} />
              </CreateActionProvider>
          </RemoveActionProvider>
      </ListActionProvider>
    );
};
